import { BehaviorSubject, Observable, Subject } from 'rxjs';
/* eslint-disable no-underscore-dangle */
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  private _epgStop = new Subject<void>();
  private _storefrontReload = new Subject<void>();
  private _searchReload = new Subject<void>();
  private _settingsReload = new Subject<void>();
  private _collectionReload = new Subject<void>();
  private _menuIndexReload = new Subject<void>();
  private _appState = new Subject<boolean>();
  private _epgReload = new Subject<void>();
  // login intervals
  public activationTokenInterval: any;
  public activationCodeInterval: any;
  // store if the continue watching from storefront need to restart the position
  private updatecontinueWatchingPosition: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  // size and theme configuration
  // store the time when the config is loaded
  private storeFrontTime = 0;
  // store the active tab
  private activetab = '';
  // store the id of the home tab
  private homeTabId = '';
  // store the details url
  private detailsurl = '';
  // store if the profile is predefined
  private ispredefinedProfile = false;
  // store the collection
  private _collection = [];
  // store the backroutes
  private backroutes = [];
  // store init load
  private initiaLLoad = true;
  //store the config time
  private configtime = 0;
  // store if the user has selected a profile
  private profileSelected = false;
  //previus an current url
  private currenturl = null;
  private previousurl = null;
  //reload my-content
  private reloadmycontent = false;
  // is from deeplink
  private isFromdeeplink = false;
  // is from continue watching carousel (my-content or storefront)
  private iscontinuewatching = false;
  // store if the user enter from settings to edit profile
  private isfromSettings = false;
  // store if we need to reset the focos on collections page
  private resetCollectionFocus = false;
  // check if tizen priview was already shown
  private tizenPreviewShown = false;
  // playback start time
  private playbackStartedTime: number;
  //Time taken for parental dialog
  private parentalDialogTime: number;
  // content is played directly without details
  private redirectToPlayer: boolean;
  // tabs url
  private tabsurl = [];
  // user is navigating from hero sf
  private isNavigatingfromhero = false;
  // check if storefront is loaded
  private isapploaded = false;


  get isAppLoaded(): boolean {
    return this.isapploaded;
  }

  set isAppLoaded(value: boolean) {
    this.isapploaded = value;
  }

  get tabsUrl(): string[] {
    return this.tabsurl;
  }

  set tabsUrl(value: string[]) {
    this.tabsurl = value;
  }

  get epgStop(): Observable<void> {
    return this._epgStop.asObservable();
  }

  stopEpg() {
    this._epgStop.next();
  }

  get menuIndexReload(): Observable<void> {
    return this._menuIndexReload.asObservable();
  }

  reloadMenuIndex() {
    this._menuIndexReload.next();
  }

  appState(): Observable<boolean> {
    return this._appState.asObservable();
  }

  updateAppState(isInForeground: boolean) {
    this._appState.next(isInForeground);
  }

  get storefrontReload() {
    return this._storefrontReload.asObservable();
  }

  reloadStorefront() {
    this._storefrontReload.next();
  }

  get searchReload() {
    return this._searchReload.asObservable();
  }

  reloadSearch() {
    this._searchReload.next();
  }

  get settingsReload() {
    return this._settingsReload.asObservable();
  }

  reloadSettings() {
    this._settingsReload.next();
  }

  get collectionReload() {
    return this._collectionReload.asObservable();
  }

  reloadCollection() {
    this._collectionReload.next();
  }

  get isTizenPreviewShown(): boolean {
    return this.tizenPreviewShown;
  }

  set isTizenPreviewShown(value: boolean) {
    this.tizenPreviewShown = value;
  }

  get isRedirectToPlayer(): boolean {
    return this.redirectToPlayer;
  }

  set isRedirectToPlayer(value: boolean) {
    this.redirectToPlayer = value;
  }

  get resetCollectionFocusValue(): boolean {
    return this.resetCollectionFocus;
  }

  set resetCollectionFocusValue(value: boolean) {
    this.resetCollectionFocus = value;
  }

  get playbackStartTime(): number {
    return this.playbackStartedTime;
  }

  set playbackStartTime(value: number) {
    this.playbackStartedTime = value;
  }

  get parentalDisplayDuration(): number {
    return this.parentalDialogTime;
  }

  set parentalDisplayDuration(value: number) {
    this.parentalDialogTime = value;
  }

  get storefrontTime(): number {
    return this.storeFrontTime;
  }

  set storefrontTime(value: number) {
    this.storeFrontTime = value;
  }

  get activeTab(): string {
    return this.activetab;
  }

  set activeTab(value: string) {
    this.activetab = value;
  }

  get homeTab(): string {
    return this.homeTabId;
  }

  set homeTab(value: string) {
    this.homeTabId = value;
  }

  get detailsUrl(): string {
    return this.detailsurl;
  }

  set detailsUrl(value: string) {
    this.detailsurl = value;
  }

  get isPredefinedProfile(): boolean {
    return this.ispredefinedProfile;
  }

  set isPredefinedProfile(value: boolean) {
    this.ispredefinedProfile = value;
  }

  get collection(): string[] {
    return this._collection;
  }

  set collection(value: string[]) {
    this._collection = value;
  }

  get backRoutes(): string[] {
    return this.backroutes;
  }

  set backRoutes(value: string[]) {
    this.backroutes = value;
  }

  get initialLoad(): boolean {
    return this.initiaLLoad;
  }

  set initialLoad(value: boolean) {
    this.initiaLLoad = value;
  }

  get configTime(): number {
    return this.configtime;
  }

  set configTime(value: number) {
    this.configtime = value;
  }

  get profileSelectedStatus(): boolean {
    return this.profileSelected;
  }

  set profileSelectedStatus(value: boolean) {
    this.profileSelected = value;
  }

  get previousUrl(): string {
    return this.previousurl;
  }

  set previousUrl(url: string) {
    this.previousurl = url;
  }

  get currentUrl(): string {
    return this.currenturl;
  }

  set currentUrl(url: string) {
    this.currenturl = url;
  }

  get reloadMyContent(): boolean {
    return this.reloadmycontent;
  }

  set reloadMyContent(value: boolean) {
    this.reloadmycontent = value;
  }

  get isFromDeeplink(): boolean {
    return this.isFromdeeplink;
  }

  set isFromDeeplink(value: boolean) {
    this.isFromdeeplink = value;
  }

  getUpdateContinueWatchingPosition(): Observable<boolean> {
    return this.updatecontinueWatchingPosition.asObservable();
  }

  setUpdateContinueWatchingPosition(val: boolean): void {
    this.updatecontinueWatchingPosition.next(val);
  }

  get isContinueWatching(): boolean {
    return this.iscontinuewatching;
  }

  set isContinueWatching(iscw: boolean) {
    this.iscontinuewatching = iscw;
  }

  get isFromSettings(): boolean {
    return this.isfromSettings;
  }

  set isFromSettings(value: boolean) {
    this.isfromSettings = value;
  }

  get isNavigatingFromHero() {
    return this.isNavigatingfromhero;
  }

  set isNavigatingFromHero(value: boolean) {
    this.isNavigatingfromhero = value;
  }

  closeCodeInterval() {
    if (this.activationCodeInterval) {
      clearTimeout(this.activationCodeInterval);
      this.activationCodeInterval = null;
    }
  }

  closeTokenInterval() {
    if (this.activationTokenInterval) {
      clearInterval(this.activationTokenInterval);
      this.activationTokenInterval = null;
    }
  }

  get epgReload() {
    return this._epgReload.asObservable();
  }

  reloadEPG() {
    this._epgReload.next();
  }
}
